import { render, staticRenderFns } from "./course-details.html?vue&type=template&id=e0020bd8&scoped=true&"
import script from "./course-details.js?vue&type=script&lang=js&"
export * from "./course-details.js?vue&type=script&lang=js&"
import style0 from "./course-details.scss?vue&type=style&index=0&id=e0020bd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0020bd8",
  null
  
)

export default component.exports